<div class="container">
  @if (showPopup) {
  <div class="popup-message">
    <button class="close-button" (click)="showPopup = false">×</button>
  </div>
  }

  <mic-breadcrumb id="premold-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('preMoldText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="premold-header">
    <h2 class="page-title premold-heading" id="premold-heading">{{ translationService.translate('preMoldText') }}</h2>
    <div class="action-bar">
      <button
        id="reset-filters"
        type="button"
        mat-flat-button
        color="accent"
        class="btn-clear premold-action-button"
        (click)="resetFilters()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.translate('clearSelectionText') }}
      </button>
      <span
        [matTooltip]="
          productSaveDisabled
            ? this.translationService.translate('comingSoonText')
            : !saveEnabled
            ? this.translationService.translate('userCannotSaveText')
            : !isModified
            ? this.translationService.translate('noModifiedText')
            : null
        "
        matTooltipPosition="above"
      >
        <button
          id="save"
          type="button"
          mat-flat-button
          color="primary"
          class="btn-primary premold-action-button"
          (click)="saveDropdowns()"
          [disabled]="!saveEnabled || !isModified"
        >
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
      </span>
      @if (!isProduction) {
      <button id="export-button-top" mat-flat-button color="primary" class="btn-export premold-action-button" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        {{ translationService.translate('exportButtonText') }}
      </button>
      }
    </div>
  </div>

  <mat-card class="premold-filter-card">
    <form [formGroup]="formGroup">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          id="treads"
          formControlName="treads"
          [data]="treads"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('treadSearchText') }}"
          label="{{ translationService.translate('treadText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="treadWidths"
          formControlName="treadWidths"
          [data]="treadWidths"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectTreadWidthText') }}"
          label="{{ translationService.translate('treadWidthText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="treadBrands"
          formControlName="treadBrands"
          [data]="treadBrands"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectTreadBrandText') }}"
          label="{{ translationService.translate('treadBrandText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="applications"
          formControlName="applications"
          [data]="applications"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectApplicationText') }}"
          label="{{ translationService.translate('applicationText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="axles"
          formControlName="axles"
          [data]="axles"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectAxleText') }}"
          label="{{ translationService.translate('axleText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="casingSizes"
          formControlName="casingSizes"
          [data]="casingSizes"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectCasingSizeText') }}"
          label="{{ translationService.translate('casingSizeText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  <div id="pre-mold-table" class="cam-table table-container btn-table">
    <div class="table-wrapper">
      <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>

        <ng-container *micTableColumnSelector>
          <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
            <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
          </button>
          <mat-menu #colMenu="matMenu">
            <div
              class="column-menu-content column-menu-list"
              cdkDropList
              [cdkDropListData]="columnOrder"
              (cdkDropListDropped)="onColumnDrop($event)"
            >
              @for (key of columnOrder; track key) {
              <div class="column-menu-item" cdkDrag>
                <mat-icon class="column-drag-handle" cdkDragHandle aria-hidden="true">drag_indicator</mat-icon>
                <mat-checkbox
                  [checked]="columnVisibility[key]"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                  (change)="toggleColumn(key)"
                  >{{ columnNames[key] || key }}</mat-checkbox
                >
              </div>
              }
            </div>
          </mat-menu>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'treadImageCell'">
          @if (item.treadImage && item.treadImage.trim() !== '') {
          <a href="#" (click)="openImageDialog($event, item.treadImage, item)"> View Image </a>
          }
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'dealerTreadDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [data]="rollPartNumbers"
            [widthConfig]="{ width: '100%' }"
            [virtualScroll]="true"
            [formControl]="getControl(item, 'dealerTreadNo')"
          >
          </mic-dropdown-search>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'dealerCTCDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [data]="rollPartNumbers"
            [virtualScroll]="true"
            [widthConfig]="{ width: '100%' }"
            [formControl]="getControl(item, 'dealerCTC')"
          >
          </mic-dropdown-search>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'sideWallNoInput'">
          <div class="table-input-wrapper">
            <label class="table-input-label" for="side-wall-number-input">Sidewall number</label>
            <input
              id="side-wall-number-input"
              matInput
              type="number"
              min="0"
              max="999999"
              aria-label="Sidewall number"
              [formControl]="getControl(item, 'sideWallNo')"
              class="table-input"
            />
          </div>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'sideWallWidthInput'">
          <div class="table-input-wrapper">
            <label class="table-input-label" for="side-wall-width-input">Sidewall width</label>
            <input
              id="side-wall-width-input"
              matInput
              type="number"
              min="0"
              max="999"
              aria-label="Sidewall width"
              [formControl]="getControl(item, 'sideWallWidth')"
              class="table-input"
            />
          </div>
        </ng-container>
      </mic-table>
    </div>
  </div>
  @if (isImageDialogOpen) {
  <div class="image-dialog" cdkDrag>
    <div class="dialog-header" cdkDragHandle>
      <span>{{ translationService.translate('treadImageText') }}</span>
      <button class="close-button" (click)="closeImageDialog()">×</button>
    </div>
    <div class="dialog-content">
      @if (selectedImage) {
      <img src="{{ imageData }}" alt="Tread" />
      } @if (selectedImageLabel) {
      <div class="image-label">
        {{ selectedImageLabel }}
      </div>
      }
    </div>
  </div>
  }

  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
